import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";

export class siteServicesTaskSelectionSearchCtrl implements IController {

  clearOnSelect: any;
  onSelect: Function;

  private deliveriesRef: any;
  private loadLimit: number;
  private searchText: string;

  /* @ngInject */
  constructor(private $deliveries, private $q: IQService) {
  }

  $onInit() {
    this.deliveriesRef = this.$deliveries();
    this.loadLimit = 20;
    this.searchText = '';
  }

  querySearch(query) {
    return this.deliveriesRef.$getAll({query: query, limit: this.loadLimit})
      .then((ids) => {
        return this.deliveriesRef.$asyncValues(ids)
      })
      .then((services) => {
        let tasks = [];

        _.forEach(services, (s) => {
          _.forEach(s.taskList, (t) => {
            _.set(t, 'account', s.account);
            _.set(t, 'agent', s.agent);
            _.set(t, 'serviceType', s.serviceType);
            _.set(t, 'serviceId', s.id);
            _.set(t, 'externalId', s.externalId);
            _.set(t, 'serviceExternalId', s.externalId);
          });
          tasks = tasks.concat(s.taskList)
        });

        return this.$q.all(tasks)
      })
  }

  selectedItemChange(item) {
    this.onSelect({relatedTask: item});
    if (this.clearOnSelect) {
      this.searchText = '';
    }
  }

}

angular
  .module('bringoz.admin.orders')
  .component('siteServicesTaskSelectionSearch', {
    bindings: {
      clearOnSelect: '@?',
      onSelect: '&',
    },
    template: require('./site-services-task-selection-search.html').default,
    controller: siteServicesTaskSelectionSearchCtrl
  });
